import Popover from '@/components/base/floating/popover/popover';
import InputStepper from '@/components/base/form/input/input-stepper';
import type { useAddProductToCartMutation } from '@/features/basket/api/mutation/change-product-quantity';
import ProductRemovalConfirmationTooltipContent from '@/features/basket/components/product-card/product-removal-confirmation-tooltip-content';
import type { Product } from '@/features/basket/types/product';
import { ga4_changeQuantity } from '@/libs/ga4/actions/change-quantity';
import { useToggle } from '@react-hookz/web';
import { useState } from 'react';

interface Props {
  quantity: number;
  product: Product;
  mutation: ReturnType<typeof useAddProductToCartMutation>;
  testId?: string;
}

const QuantityStepper = ({ quantity, mutation, product, testId }: Props) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  //Value doesn't matter this is only to trigger reset default values in inputStepper
  const [triggerReset, toggleTriggerReset] = useToggle(false);

  const changeQuantity = (newQuantity: number) => {
    if (newQuantity !== quantity) {
      ga4_changeQuantity({ product, quantity, newQuantity });
      mutation.mutate({
        productId: product.externalId,
        productQuantity: Math.max(0, newQuantity),
      });
    }
  };

  const maybeChangeQuantity = (newQuantity: number) => {
    if (newQuantity === 0) {
      setIsPopoverOpen(true);
    } else {
      changeQuantity(newQuantity);
    }
  };

  return (
    <Popover
      Content={
        <ProductRemovalConfirmationTooltipContent
          onDismiss={() => {
            setIsPopoverOpen(false);
            toggleTriggerReset();
          }}
          onConfirm={() => changeQuantity(0)}
        />
      }
      placement="top"
      isOpen={isPopoverOpen}
      setIsOpen={setIsPopoverOpen}
    >
      <InputStepper
        value={quantity}
        onChange={maybeChangeQuantity}
        isLoading={mutation.isPending}
        triggerReset={triggerReset}
        testId={testId}
      />
    </Popover>
  );
};

export default QuantityStepper;
